export default {
  name: "System settings",
}
